export default __webpack_public_path__ + "static/media/logo.34c77fe0.png";